import React from 'react';
import { Skeleton } from '@yme/common/components/skeletons';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
const cardsArr = Array(3).fill('contentGridSkeletonItem');
export function ContentGridSkeleton() {
    return (React.createElement(React.Fragment, null, cardsArr.map((item, index) => (React.createElement(FlexWrapper, { mt: INDENT.xl, key: `${item}_${index}`, flexDirection: "column" },
        React.createElement(Skeleton, { skeletonProps: {
                height: 28,
                width: 400,
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 24,
                width: 400,
                style: {
                    marginTop: 8,
                },
            } }),
        React.createElement(Skeleton, { skeletonProps: {
                height: 20,
                width: 200,
                style: {
                    marginTop: 8,
                },
            } }))))));
}
